// Vista rubros
import React from 'react';
import {Link} from 'react-router-dom';
import API from '../../configAPI';
import PulseLoader from 'react-spinners/PulseLoader';
import CONFIG from '../../config';
import BannerLarge from '../partials/BannerLarge';

class AllItems extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            items : [],
            loading : true,
        }
    }
    componentDidMount(){
        this.getItems();
    }
    getItems = () =>{
        API.PRODUCTS('items-with-categories')
        .then(resp =>{
            this.setState({
                items : resp.data,
                loading : false
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    render(){

        return(
            <div className="container-fluid mt-3 mb-3">
                {/* <BannerLarge 
                    url="https://dossierdearquitectura.com/"
                    image="https://dossierdearquitectura.com/banner/da728x160.jpg"
                    title="Visite Dossier de Arquitectura"
                /> */}
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="page-header">Todas las categorías</div>
                    <div className="row d-flex flex-wrap  justify-content-beetwen">

                        {this.state.items.map((item,index) =>(
                            <article className="col-6 col-sm-6 col-md-3 mt-2" key={index}>
                                <div className="rubro">
                                    <Link to={`/productos/${item.slug}`}>
                                            <img src={item.url_image} alt={item.name}/>
                                            <h3>{item.name}</h3>
                                    </Link>
                                    <ul>
                                        {item.categories.map((categ,index2)=>(
                                            (index2 < 5 ?
                                                <li key={index2}><Link to={`/productos/${item.slug}/${categ.slug}`}>{categ.name}</Link></li>
                                                : ''
                                            )
                                        ))}
                                        <li><Link to={`/productos/${item.slug}`} className="link">Ver más</Link></li>
                                    </ul>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>

                <BannerLarge 
                    url="https://dossierdearquitectura.com/"
                    image="https://dossierdearquitectura.com/banner/da728x160.jpg"
                    title="Visite Dossier de Arquitectura"
                />
            </div>
        )
    }
}
export default AllItems;